module.exports = __webpack_public_path__ + "static/media/img4.c22fb9b3.svg";